var _path, _path2, _circle, _ellipse, _mask, _path3, _path4, _line, _line2, _circle2, _path5, _path6, _circle3, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 66,
    viewBox: "0 0 105 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9317 32.4951C59.9317 49.0448 46.5155 62.461 29.9658 62.461C13.4162 62.461 0 49.0448 0 32.4951C0 15.9455 13.4162 2.5293 29.9658 2.5293C46.5155 2.5293 59.9317 15.9455 59.9317 32.4951ZM4.79454 32.4951C4.79454 46.3969 16.0641 57.6665 29.9658 57.6665C43.8676 57.6665 55.1372 46.3969 55.1372 32.4951C55.1372 18.5934 43.8676 7.32383 29.9658 7.32383C16.0641 7.32383 4.79454 18.5934 4.79454 32.4951Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39727 32.4951C1.07329 32.4951 -0.00996914 31.4201 0.0958337 30.1003C0.471651 25.4126 1.94683 20.867 4.41576 16.838C7.30329 12.126 11.4376 8.3043 16.3616 5.79538C21.2857 3.28646 26.8076 2.18808 32.3169 2.62167C37.8263 3.05527 43.1084 5.00395 47.5793 8.25227C52.0503 11.5006 55.5358 15.922 57.6507 21.0277C59.7655 26.1334 60.4273 31.7245 59.5628 37.1828C58.6982 42.6412 56.3411 47.7541 52.752 51.9564C49.6833 55.5495 45.816 58.3572 41.4738 60.1632C40.2513 60.6716 38.8941 59.9736 38.485 58.7144C38.0759 57.4552 38.771 56.1133 39.9855 55.5863C43.4896 54.0658 46.6119 51.7631 49.1063 48.8426C52.1211 45.3127 54.1011 41.0178 54.8273 36.4328C55.5534 31.8478 54.9976 27.1513 53.2211 22.8625C51.4446 18.5737 48.5168 14.8597 44.7612 12.1311C41.0056 9.40254 36.5686 7.76565 31.9408 7.40143C27.3129 7.03721 22.6745 7.95985 18.5383 10.0673C14.4021 12.1748 10.9293 15.3851 8.50378 19.3432C6.49702 22.6179 5.27184 26.299 4.9086 30.1014C4.7827 31.4194 3.72124 32.4951 2.39727 32.4951Z",
    fill: "#D0D5DD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.952,
    cy: 57.2167,
    r: 4.49402,
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.6823,
    cy: 28.1446,
    rx: 12.5827,
    ry: 12.9982,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_353_8106",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5065 42.6595C34.5065 41.6744 35.1172 40.8065 35.9794 40.3301C40.188 38.0043 43.0511 33.4198 43.0511 28.1445C43.0511 20.5172 37.0656 14.334 29.6821 14.334C22.2985 14.334 16.313 20.5172 16.313 28.1445C16.313 33.2755 19.0216 37.7529 23.0424 40.1341C23.9081 40.6469 24.5178 41.5383 24.5178 42.5444C24.5178 43.9383 25.6478 45.0682 27.0416 45.0682H32.0977C33.428 45.0682 34.5065 43.9898 34.5065 42.6595Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5065 42.6595C34.5065 41.6744 35.1172 40.8065 35.9794 40.3301C40.188 38.0043 43.0511 33.4198 43.0511 28.1445C43.0511 20.5172 37.0656 14.334 29.6821 14.334C22.2985 14.334 16.313 20.5172 16.313 28.1445C16.313 33.2755 19.0216 37.7529 23.0424 40.1341C23.9081 40.6469 24.5178 41.5383 24.5178 42.5444C24.5178 43.9383 25.6478 45.0682 27.0416 45.0682H32.0977C33.428 45.0682 34.5065 43.9898 34.5065 42.6595Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5511 28.1445C41.5511 32.8695 38.9884 36.9534 35.2538 39.0172L36.7049 41.6429C41.3875 39.0552 44.5511 33.9701 44.5511 28.1445H41.5511ZM29.6821 15.834C36.1916 15.834 41.5511 21.2993 41.5511 28.1445H44.5511C44.5511 19.7351 37.9396 12.834 29.6821 12.834V15.834ZM17.813 28.1445C17.813 21.2993 23.1725 15.834 29.6821 15.834V12.834C21.4245 12.834 14.813 19.7351 14.813 28.1445H17.813ZM23.8067 38.8435C20.2372 36.7295 17.813 32.74 17.813 28.1445H14.813C14.813 33.8109 17.806 38.7763 22.278 41.4248L23.8067 38.8435ZM32.0977 43.5682H27.0416V46.5682H32.0977V43.5682ZM23.0178 42.5444C23.0178 44.7667 24.8193 46.5682 27.0416 46.5682V43.5682C26.4762 43.5682 26.0178 43.1098 26.0178 42.5444H23.0178ZM22.278 41.4248C22.7809 41.7226 23.0178 42.1682 23.0178 42.5444H26.0178C26.0178 40.9083 25.0353 39.5711 23.8067 38.8435L22.278 41.4248ZM32.0977 46.5682C34.2565 46.5682 36.0065 44.8182 36.0065 42.6595H33.0065C33.0065 43.1613 32.5996 43.5682 32.0977 43.5682V46.5682ZM35.2538 39.0172C34.0079 39.7058 33.0065 41.0289 33.0065 42.6595H36.0065C36.0065 42.32 36.2265 41.9073 36.7049 41.6429L35.2538 39.0172Z",
    fill: "#475467",
    mask: "url(#path-5-inside-1_353_8106)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26.1753,
    y1: 47.1123,
    x2: 32.8478,
    y2: 47.1123,
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 27.0835,
    y1: 49.9062,
    x2: 31.9399,
    y2: 49.9062,
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0005 7.4668V20.5335",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4668 14H97.5335",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 52,
    r: 13.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4668 52H97.5335",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon3);
export default __webpack_public_path__ + "static/media/faq-icon3.9b369bf5e7ab493e51bbef6468273a48.svg";
export { ForwardRef as ReactComponent };